import { UPDATE_VIEW, UPDATE_VIEW_COLOR, RESTART } from '../actions';

export const view = (state = { id: 'loading', prev: null, color: 'white' }, action) => {
  switch (action.type) {
    case UPDATE_VIEW:
      return Object.assign({}, {
        ...state,
        prev: state.id,
        id: action.id
      });
    case UPDATE_VIEW_COLOR:
      return Object.assign({}, {
        ...state,
        color: action.color
      }); 
    case RESTART:
      return Object.assign({}, {
        ...state,
        prev: state.id,
        id: 'quiz'
      });
    default:
      return state;
  }
}
